import { v4 as uuid } from 'uuid';
import { ToastType } from '../Components/Interactive/Toast/Toast';
export class ToastManager {
    setToasts;
    registerSetState(setToasts) {
        this.setToasts = setToasts;
    }
    isRegistered() {
        return this.setToasts !== undefined;
    }
    showToast(props) {
        if (!this.setToasts) {
            return undefined;
        }
        const { text, type, autoCloseMs, action, category } = props;
        const newToast = {
            id: uuid(),
            text,
            type,
            autoCloseMs,
            action,
            category: category ?? text,
        };
        this.setToasts((toasts) => {
            return [...toasts.filter((x) => x.category !== newToast.category), newToast];
        });
        return newToast;
    }
    showError(props) {
        return this.showToast({ ...props, type: ToastType.Error });
    }
    showWarning(props) {
        return this.showToast({ ...props, type: ToastType.Warning });
    }
    showSuccess(props) {
        return this.showToast({ ...props, type: ToastType.Success });
    }
    showInfo(props) {
        return this.showToast({ ...props, type: ToastType.Info });
    }
    hideToast(toast) {
        if (!this.setToasts) {
            return;
        }
        this.setToasts((toasts) => {
            const updatedToasts = [...toasts];
            const toastIndex = updatedToasts.indexOf(toast);
            if (toastIndex >= 0) {
                updatedToasts.splice(toastIndex, 1);
            }
            return updatedToasts;
        });
    }
}
const toastManager = new ToastManager();
export default toastManager;
//# sourceMappingURL=ToastManager.js.map